/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getPosStatusNotificationConfig } from '../fn/pos-status-notification-configuration/get-pos-status-notification-config';
import { GetPosStatusNotificationConfig$Params } from '../fn/pos-status-notification-configuration/get-pos-status-notification-config';
import { PosStatusNotificationConfiguration } from '../models/pos-status-notification-configuration';
import { upsertPosStatusNotification } from '../fn/pos-status-notification-configuration/upsert-pos-status-notification';
import { UpsertPosStatusNotification$Params } from '../fn/pos-status-notification-configuration/upsert-pos-status-notification';

@Injectable({ providedIn: 'root' })
export class PosStatusNotificationConfigurationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPosStatusNotificationConfig()` */
  static readonly GetPosStatusNotificationConfigPath = '/stores/{storeId}/pos-status-notification';

  /**
   * Gets the store POS Status Notification Configuration.
   *
   * Gets the store POS Status Notification Configuration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPosStatusNotificationConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPosStatusNotificationConfig$Response(params: GetPosStatusNotificationConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PosStatusNotificationConfiguration>>> {
    return getPosStatusNotificationConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the store POS Status Notification Configuration.
   *
   * Gets the store POS Status Notification Configuration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPosStatusNotificationConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPosStatusNotificationConfig(params: GetPosStatusNotificationConfig$Params, context?: HttpContext): Observable<Array<PosStatusNotificationConfiguration>> {
    return this.getPosStatusNotificationConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PosStatusNotificationConfiguration>>): Array<PosStatusNotificationConfiguration> => r.body)
    );
  }

  /** Path part for operation `upsertPosStatusNotification()` */
  static readonly UpsertPosStatusNotificationPath = '/stores/{storeId}/pos-status-notification';

  /**
   * Upserts POS Status Notification Configuration.
   *
   * Upserts POS Status Notification Configuration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertPosStatusNotification()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertPosStatusNotification$Response(params: UpsertPosStatusNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PosStatusNotificationConfiguration>>> {
    return upsertPosStatusNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * Upserts POS Status Notification Configuration.
   *
   * Upserts POS Status Notification Configuration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertPosStatusNotification$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertPosStatusNotification(params: UpsertPosStatusNotification$Params, context?: HttpContext): Observable<Array<PosStatusNotificationConfiguration>> {
    return this.upsertPosStatusNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PosStatusNotificationConfiguration>>): Array<PosStatusNotificationConfiguration> => r.body)
    );
  }

}
